<template>
  <v-chip-group column>
    <v-chip v-if="includeAll">All</v-chip>
    <v-chip v-for="tag in tags" :key="tag.id" :href="`/tag/${tag.id}`">
      <v-icon v-if="tag.icon" :icon="tag.icon" />
      <Translation :item="tag.name" />
    </v-chip>
  </v-chip-group>
</template>
<script lang="ts" setup>
import type { Tag } from "@/types";

defineProps<{
  tags: Tag[];
  includeAll?: boolean;
}>();
</script>
